import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const absoluteOriginConfig = {
transform(props) {
  const { transform, align, ellipsis, ...rest } = props;
  const centerStyle = align === "center" ? {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  } : null;
  const textEllipsis = ellipsis && {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  };
  return {
    position: "absolute",
    transformOrigin: "0 0",
    transform,
    ...textEllipsis,
    ...centerStyle,
    ...rest
  };
},
defaultValues:{transform:'scale(.5)',ellipsis:false}}

export const getAbsoluteOriginStyle = (styles = {}) => {
  const _styles = getPatternStyles(absoluteOriginConfig, styles)
  return absoluteOriginConfig.transform(_styles, patternFns)
}

export const absoluteOrigin = (styles) => css(getAbsoluteOriginStyle(styles))
absoluteOrigin.raw = getAbsoluteOriginStyle